<div class="container d-flex justify-content-center align-items-center flex-column text-center container-holder">
    <div>
        <div class="row">
            <div class="col-12">
                Error
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <span> Session timed out </span> 
            </div>
        </div>
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-12">
                <label>Please go to your website and start again the login process.</label>
            </div>
            <div class="col-12 d-flex justify-content-center align-items-center mt-3">
                <a [href]="redirectUrl" class="submit-btn">Go back</a>
            </div>
        </div>
    </div>
</div>